import { getRelativeLabel } from '../components/General/DocTable/DocTableIndicator';
import { processDocuments } from '../components/General/DocTable/DocTableUtils';
import i18n from '../localization/i18n';
import { IDocDefaultFields, IFieldConfig } from '../redux/project/documents/sliceProjectDocuments';
import { parseDate } from './DataUtils';
import { stringToBytes } from './StringUtils';

export const formatDocumentsToCSV = ({
    data,
    fieldSchema,
    fields,
}: {
    data: IDocDefaultFields[];
    fieldSchema: string[];
    fields: IFieldConfig[];
}): string => {
    const filteredFieldSchema = fieldSchema.filter(fs => fs !== 'files');
    const docs = processDocuments(data, fields);

    // 8187: Excel quickreport should have documents sorted numerically by DocNumber.
    docs.sort((a, b) => (a['DocNumber'] ?? '').localeCompare(b['DocNumber'] ?? '', undefined, { numeric: true }));

    const headersRow = filteredFieldSchema
        .map(item => fields.find(f => f.field === item)?.headerName?.[i18n.language] ?? '')
        .join(';');

    const rows = docs.reduce((rowsArray, doc) => {
        rowsArray = [
            ...rowsArray,
            filteredFieldSchema
                .map(fs => {
                    const fieldsType = fields.find(f => f.field === fs).type;
                    if (fieldsType === 'date') {
                        return parseDate(doc[fs]) ?? '';
                    }
                    if (fieldsType === 'dateRelative' || fieldsType === 'numberRelative') {
                        const { label, dateRelative } = getRelativeLabel(
                            doc[fs],
                            fieldsType === 'dateRelative',
                        );
                        return label ? `${label} | ${dateRelative}` : dateRelative || '';
                    }
                    return doc[fs] ?? '';
                })
                .join(';'),
        ];
        return rowsArray;
    }, []);
    return [headersRow, ...rows].join('\n');
};

export const downloadCSVFile = ({
    CSVData,
    reportName,
}: {
    CSVData: string;
    reportName: string;
}): void => {
    const bytes = stringToBytes(CSVData);
    const CSVFile = new Blob([bytes.buffer], { type: 'text/csv; charset=ISO-8859-1' });

    // Create to temporary link to initiate download process
    const tempLink = document.createElement('a');

    // Download csv file
    tempLink.download = `${reportName}.csv`;
    const url = window.URL.createObjectURL(CSVFile);
    tempLink.href = url;

    // This link should not be displayed
    tempLink.style.display = 'none';
    document.body.appendChild(tempLink);

    // Automatically click the link to trigger download
    tempLink.click();
    document.body.removeChild(tempLink);
};
